<div class="dialog">
  <h4 mat-dialog-title>{{ 'common_modify' | translate }}</h4>
  <form #form="ngForm" [appEnterToSave]="data?.value">
    <mat-form-field>
      <mat-label>{{ 'dialog_edit_combustible_field_percentage' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="data.value" min="0" max="100" name="pourcentage" required />
      <mat-error *ngIf="!data?.value" [innerHTML]="'dialog_edit_combustible_error_percentage' | translate"></mat-error>
    </mat-form-field>
    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button [mat-dialog-close]="data?.value" color="accent" [disabled]="!form.valid">{{ 'common_btn_save' | translate }}</button>
    </div>
  </form>
</div>
